if (!customElements.get("product-sticky-cart")) {
  class ProductStickyCart extends HTMLElement {
    connectedCallback() {
      const section = this.closest(".shopify-section");
      const product = section?.querySelector(".product");
      this.source = product?.querySelector('product-configurator .product__submit button[type="submit"]');
      if (!this.source || !window.IntersectionObserver) return;

      // Forward to the original form so validation, configuration and cart events stay shared.
      this.button = this.source.cloneNode(true);
      this.button.removeAttribute("id");
      this.button.removeAttribute("form");
      this.button.type = "button";
      this.querySelector("[data-sticky-action]").replaceChildren(this.button);
      this.button.addEventListener("click", () => this.source.click());

      const price = product.querySelector("[data-pdp-price]");
      const fulfillment = product.querySelector(".product__fulfillment-info");
      const sync = () => {
        this.button.disabled = this.source.disabled;
        this.button.className = this.source.className;
        const label = this.button.querySelector("[data-submit-label]");
        if (label) label.textContent = this.source.querySelector("[data-submit-label]")?.textContent || "";
        this.querySelector("[data-sticky-price]").textContent = price?.textContent || "";
        const shipping = this.querySelector("[data-sticky-shipping]");
        shipping.textContent = fulfillment?.querySelector(".shipping-info.selected")?.textContent.trim() || "";
        shipping.hidden = !shipping.textContent;
      };
      sync();
      this.mutations = new MutationObserver(sync);
      [this.source, price, fulfillment].filter(Boolean).forEach((element) => {
        this.mutations.observe(element, { attributes: true, childList: true, characterData: true, subtree: true });
      });
      this.visibilityHandler = () => this.updateVisibility();
      this.footer = document.querySelector(".page-footer");
      this.intersection = new IntersectionObserver(this.visibilityHandler);
      this.intersection.observe(this.source);
      if (this.footer) this.intersection.observe(this.footer);
      // Also handle a fast scroll that skips the viewport between observer samples.
      window.addEventListener("scroll", this.visibilityHandler, { passive: true });
    }

    shouldBeVisible() {
      const rect = this.source.getBoundingClientRect();
      const footerTop = this.footer?.getBoundingClientRect().top ?? Infinity;
      return rect.width > 0 && rect.height > 0 && rect.bottom < 0 && footerTop >= window.innerHeight;
    }

    updateVisibility() {
      if (!this.shouldBeVisible()) {
        window.clearTimeout(this.revealTimer);
        this.revealTimer = null;
        if (this.contains(document.activeElement)) this.source.focus({ preventScroll: true });
        this.hidden = true;
        window.clearInterval(this.cookieWidgetTimer);
        return;
      }
      if (!this.hidden || this.revealTimer != null) return;
      this.revealTimer = window.setTimeout(() => {
        this.revealTimer = null;
        if (!this.isConnected || !this.shouldBeVisible()) return;
        this.hidden = false;
        if (!this.styleCookieWidget()) {
          // Pandectes loads asynchronously and renders its launcher in a shadow root.
          this.cookieWidgetTimer = window.setInterval(() => {
            if (this.styleCookieWidget()) window.clearInterval(this.cookieWidgetTimer);
          }, 500);
        }
      }, 200);
    }

    styleCookieWidget() {
      const root = document.querySelector("pandectes-cmp")?.shadowRoot;
      if (!root) return false;
      if (!root.querySelector("[data-iwc-sticky-cookie-style]")) {
        const style = document.createElement("style");
        style.dataset.iwcStickyCookieStyle = "";
        // Only hide the launcher; keep consent dialogs and their controls available.
        style.textContent = "button.widget { display: var(--iwc-sticky-cookie-display, revert) !important; }";
        root.append(style);
      }
      return true;
    }

    disconnectedCallback() {
      window.removeEventListener("scroll", this.visibilityHandler);
      window.clearTimeout(this.revealTimer);
      this.revealTimer = null;
      this.hidden = true;
      window.clearInterval(this.cookieWidgetTimer);
      this.mutations?.disconnect();
      this.intersection?.disconnect();
    }
  }

  customElements.define("product-sticky-cart", ProductStickyCart);
}
